export default "__VITE_ASSET__CfgNtR6K__"